import * as React from 'react'
import { useUserAPI } from '../../../../../providers/UserAPIProvider'
import MediaAvatar from '../../../../atoms/MediaAvatar'
import OverflowText from '../../../../atoms/OverflowText'
import useStyles from './styles'

const RemoveIcon = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.00004 14.6673C11.6667 14.6673 14.6667 11.6673 14.6667 8.00065C14.6667 4.33398 11.6667 1.33398 8.00004 1.33398C4.33337 1.33398 1.33337 4.33398 1.33337 8.00065C1.33337 11.6673 4.33337 14.6673 8.00004 14.6673Z'
      stroke='#8F8F8F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.11328 9.88661L9.88661 6.11328'
      stroke='#8F8F8F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.88661 9.88661L6.11328 6.11328'
      stroke='#8F8F8F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const AsigneeListRow = ({ userId, handleRemoveAsignee }) => {
  const { allUsers, loadUser } = useUserAPI()
  const user = allUsers[userId]

  const classes = useStyles()

  React.useEffect(() => {
    if (!user) {
      loadUser(userId)
    }
  }, [user, loadUser, userId])

  return (
    <div className={classes.root}>
      <MediaAvatar user={user} className={classes.avatar} />
      <OverflowText>
        <label>{user?.name ?? 'Loading...'}</label>
      </OverflowText>
      <RemoveIcon
        className={classes.deleteBtn}
        onClick={() => {
          handleRemoveAsignee(userId)
        }}
      />
    </div>
  )
}

export default AsigneeListRow
